import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'

import ExpandIcon from '~/components/Icons/svgs/ExpandIcon'
import MinimizeIcon from '~/components/Icons/svgs/MinimizeIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

export default function SessionExpandCollapseIcon({
  isExpanded,
  onClick,
  shouldHide,
}: {
  isExpanded: boolean
  onClick: () => void
  shouldHide: boolean
}): React.ReactElement {
  const wrapperClassNames = 'absolute top-2 right-2'
  const iconColor = 'text-gray-light-fade'

  const { t } = useTranslation('generics')

  if (shouldHide) {
    return <Fragment />
  } else if (isExpanded) {
    return (
      <button className={wrapperClassNames} onClick={onClick}>
        <SVGIcon
          aria-label={t('ariaLabelButtons.collapseSessionDetails')}
          icon={MinimizeIcon}
          pathClassName={iconColor}
          size={20}
        />
      </button>
    )
  } else {
    return (
      <span className={wrapperClassNames}>
        <SVGIcon
          aria-label={t('ariaLabelButtons.expandSessionDetails')}
          icon={ExpandIcon}
          pathClassName={iconColor}
          size={20}
        />
      </span>
    )
  }
}
